export default __webpack_public_path__ + "static/media/ico-mongodb-score-moderate.151eac3c.svg";